import store from '@/store';
import { CLEAR_ERRORMSG, LOGOUT } from '@/store/action_types';
import {
  SIGNUP_PROFILE_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  SIGNUP_ORGANIZATION_ROUTE,
} from '@/router/routes';
import { RouteLocationNormalized } from 'vue-router';
import { resetLoaders } from '@/utils/loaders';

export const ifAuthDeny = async (to: any, from: any, next: Function) => {
  store.dispatch(CLEAR_ERRORMSG);
  resetLoaders();

  const sessionToken = store.getters.sessionToken;
  const accountData = store.getters.account.data;

  if (sessionToken == null || accountData == null) {
    if (to.name !== LOGIN_ROUTE) {
      return next({ name: LOGIN_ROUTE });
    } else {
      return next(); // Prevent redirect loop
    }
  }

  console.log('from.name', from.name);
  console.log('to.name', to.name);

  // if (
  //   store.getters.account.data &&
  //   !store.getters.account.data.isEmailVerified
  // ) {
  //   if (to.name === EMAIL_VERIFICATION_WALL_ROUTE) {
  //     return next();
  //   } else {
  //     return next({ name: EMAIL_VERIFICATION_WALL_ROUTE });
  //   }
  // }

  // if (!accountData.organizationId) {
  //   if (!store.getters.account.data.isEmailVerified) {
  //     return next({ name: EMAIL_VERIFICATION_WALL_ROUTE });
  //   }
  //   if (to.name === SIGNUP_ORGANIZATION_ROUTE) {
  //     return next();
  //   } else {
  //     return next({ name: SIGNUP_ORGANIZATION_ROUTE });
  //   }
  // }

  next();
};

export const logoutGuard = async (to: any, from: any, next: Function) => {};
